import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!email.trim() || busy) return;
    setBusy(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email: email.trim() });
      toast.success(res.data.message || "You're on the list. Welcome.");
      setEmail("");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form data-testid="newsletter-form" onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-lg">
      <label htmlFor="newsletter-email" className="sr-only">
        Email address
      </label>
      <input
        id="newsletter-email"
        data-testid="newsletter-email-input"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email address"
        className="flex-1 bg-[#fafafa] border border-[#cccccc] px-4 py-3 text-sm text-[#121212] focus:border-[#e02020] focus:outline-none rounded-none"
      />
      <button
        type="submit"
        data-testid="newsletter-submit-button"
        disabled={busy}
        className="px-6 py-3 bg-[#121212] text-white text-xs font-mono uppercase tracking-[.14em] hover:bg-[#e02020] transition-colors whitespace-nowrap rounded-none disabled:opacity-60"
      >
        {busy ? "Subscribing…" : "Subscribe"}
      </button>
    </form>
  );
};
